var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"betslip-stake-input__stake--terminal",on:{"click":function($event){return _vm.onStakeClicked(_vm.betSlipNamespace)}}},[_vm._v("\n    "+_vm._s(_vm.rawStake)+" "+_vm._s(_vm.$t('currencyAbbreviation'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac43dba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/terminal/app/modules/shared/betSlip/StakeInput.vue
// module id = 1992
// module chunks = 0